import React from "react";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import bannerDesk from "../../images/banner-logado-desktop.webp";
import bannerMobile from "../../images/banner-logado-mobile.webp";
import regulationButton from "../../images/regulamento-button.png";
import gLogo from "../../images/garantia_interna.png";

import garantiaRegulamento from "../../docs/Garantia_Bravecto_2026.pdf";

import "./GarantiaBravecto.scss";

const GarantiaBravecto = (props) => {
  document.title = "Clube Bravecto | Garantia Bravecto";

  return (
    <div id="GarantiaBravecto">
      <Header />
      {/* <div className="page-title">
          <span>Garantia Bravecto</span>
        </div> */}
      <div className="banner">
        <img className="bnr-desk" src={bannerDesk} alt="banner-garantia" />
        <img className="bnr-mob" src={bannerMobile} alt="banner-garantia" />
      </div>
      <div className="GarantiaBravecto__container">
        <div className="rules__main">
          <div className="rules">
            <div className="cta-buttons">
              <a
                href="https://www.garantias.msd-saude-animal.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                className="access-now-btn"
              >
                ACESSE AGORA
              </a>
              <a
                href={garantiaRegulamento}
                target="_blank"
                rel="noopener noreferrer"
                className="regulation-btn"
              >
                <img src={regulationButton} alt="regulamento" />
              </a>
            </div>
            <h4>GARANTIA PENSADA NA SUA TRANQUILIDADE</h4>
            <img src={gLogo} alt="" />
            <p>
              Bravecto e a MSD Saúde Animal estão sempre buscando o melhor para
              você. <br className="hide-mobile" />
              E, para sua tranquilidade, <br />
              oferecemos um benefício adicional: <br className="hide-mobile" />
              GARANTIA BRAVECTO.
            </p>
            <p>
              Como confiamos tanto na qualidade de{" "}
              <br className="hide-mobile" />
              Bravecto, agora disponibilizamos <br className="hide-mobile" />
              um suporte e cuidado <br className="hide-desktop" />
              adicional frente a <br className="hide-mobile" />
              doenças transmitidas por pulgas e <br className="hide-mobile" />
              carrapatos, que podem acometer seu <br className="hide-mobile" />
              pet, como: <br className="hide-desktop" />
              erliquiose, babesiose,
              <br className="hide-mobile" />
              micoplasmose, anaplasmose, <br className="hide-mobile" />
              rangeliose, borreliose, hepatozoonose,
              <br className="hide-mobile" />
              bartonelose <br className="hide-desktop" />e febre maculosa.
            </p>
            <br />
            <p>
              Para mais informações, leia o{" "}
              <a
                href={garantiaRegulamento}
                target="_blank"
                rel="noopener noreferrer"
              >
                Regulamento da Garantia Bravecto
              </a>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GarantiaBravecto;
